import React, { useState } from 'react';

import CardDialog from '~/components/CardDialog';
import { Heading } from '~/components/core';
import SkeletonTable from '~/components/core/Skeletons/SkeletonTable';
import AddDamageAssessmentTypeButton from '~/components/SystemConfiguration/DamageAssessmentTypes/AddDamageAssessmentTypeButton';
import DamageAssessmentTypesFilter from '~/components/SystemConfiguration/DamageAssessmentTypes/DamageAssessmentTypesFilter';
import DamageAssessmentTypesTable from '~/components/SystemConfiguration/DamageAssessmentTypes/DamageAssessmentTypesTable';
import OperationsBreadcrumbs from '~/components/SystemConfiguration/OperationsBreadcrumbs';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import type { OrganizationModel } from '~/components/types/organization-types';
import useDataFetcher from '~/components/useDataFetcher';
import type { DATypeConfigInfo } from '~/server_shared/openapi/data-contracts';

const DamageAssessmentTypesScreen: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showOnlyEnabled, setShowOnlyEnabled] = useState(false);
  const { organization } = useSysconfig() as { organization: OrganizationModel };

  const baseRoute = `/sysconfig/api/v1/organizations/${organization.id}/damage_assessment_type_configs`;
  const {
    isLoading,
    isError,
    data: damageAssessmentTypes = [],
    reloadData: reloadDamageAssessmentTypes,
  } = useDataFetcher<DATypeConfigInfo[]>(baseRoute);

  const displayLoading = isLoading || isError;

  return (
    <CardDialog noCardTitle>
      <OperationsBreadcrumbs currentTab="Damage Assessment Types" />
      <div className="grid grid-cols-2 items-center">
        <Heading className="mt-20">Damage Assessment Types</Heading>
        <AddDamageAssessmentTypeButton
          damageAssessmentTypes={damageAssessmentTypes}
          reloadDamageAssessmentTypes={reloadDamageAssessmentTypes}
        />
      </div>
      <DamageAssessmentTypesFilter onSearchTermChanged={setSearchTerm} onShowOnlyEnabledChanged={setShowOnlyEnabled} />
      {displayLoading ? (
        <SkeletonTable rowsCount={10} columnsCount={5} isError={isError} />
      ) : (
        <DamageAssessmentTypesTable
          damageAssessmentTypes={damageAssessmentTypes}
          reloadDamageAssessmentTypes={reloadDamageAssessmentTypes}
          searchTerm={searchTerm}
          showOnlyEnabled={showOnlyEnabled}
        />
      )}
    </CardDialog>
  );
};

export default DamageAssessmentTypesScreen;
